import { createFeatureSelector } from '@ngrx/store';
import { CryptoAddressVerifyState } from '../reducers/crypto-address-verify.reducer';

export const selectCryptoAddressVerify = createFeatureSelector<CryptoAddressVerifyState>('cryptoAddressVerify');
